import { modalStore } from "components/Common/Alert/AlertManager";
import useUserDetailQuery from "features/user/hooks/queries/useUserDetailQuery";
import { UserAuthorityType } from "models/user/UserAuthorityType";
import React from "react";
import { To, useNavigate } from "react-router-dom";

interface ProtectedRouteProps {
  redirectTo?: To;
  allowedRoles?: UserAuthorityType[];
  forAdmin?: boolean;
  children?: React.ReactNode;
}

const ProtectedRoute = ({
  redirectTo,
  allowedRoles,
  forAdmin,
  children,
}: ProtectedRouteProps) => {
  const { data: currentUser, isSuccess } = useUserDetailQuery();

  const navigate = useNavigate();

  if (!isSuccess) return;

  const { authorityDto, adminType } = currentUser;
  const authorityName = authorityDto?.name as UserAuthorityType;

  const isAdmin = !!adminType;
  const hasValidRole = allowedRoles?.includes(authorityName);
  const defaultAccess = !forAdmin && !allowedRoles;

  if (isAdmin || hasValidRole || defaultAccess) {
    return children;
  } else if (redirectTo) {
    navigate(redirectTo);
    return;
  } else {
    modalStore.register({
      id: "protected-route",
      title: "해당 페이지 접근 불가",
      content: "접근 권한이 없습니다. 관리자에게 문의해 주세요",
      onConfirm: () => {
        navigate(-1);
      },
    });
    return;
  }
};

export default ProtectedRoute;
